import {
  ESimulatorAMS275910CompoundLayerClass,
} from '@/types/simulator.ts';

const details: Record<ESimulatorAMS275910CompoundLayerClass, string> = {
  [ESimulatorAMS275910CompoundLayerClass.CLASS_0]: 'Keine Verbundschicht',
  [ESimulatorAMS275910CompoundLayerClass.CLASS_1]: '0 - 13 µm',
  [ESimulatorAMS275910CompoundLayerClass.CLASS_2]: '13 - 25 µm',
};

export default {
  details,
};
